export enum DeliveryMethodEnum {
    Undeliverable = 'VUN',
    Paper = 'VPA',
    Electronic = 'VEL'
}
